<template>
  <div>
    <div class="container">
      <el-card shadow="never">
        <h3 class="header">红云会议支撑管理云平台</h3>
        <el-form :model="user" ref="user" :rules="rules" v-if="!showRegister && !showForget">
          <el-form-item prop="name">
            <el-input v-model="user.name" prefix-icon="el-icon-user" placeholder="请输入邮箱"></el-input>
            <div class="hintBox">
              <div @click="setInput(mail)" v-for="mail in emails" :key="mail">{{ mail }}</div>
            </div>
          </el-form-item>
          <el-form-item prop="password" :style="showError ? 'margin-bottom:0;' : 'margin-bottom: 22px;'">
            <el-input
              v-model="user.password"
              type="password"
              prefix-icon="el-icon-lock"
              placeholder="请输入用户密码"
              show-password
            ></el-input>
            <span class="err" v-if="showError">用户名或密码错误</span>
          </el-form-item>
          <!-- <div class="tips findBack">找回密码</div> -->

          <el-form-item>
            <el-col :span="10">
              <el-input v-model="user.code"></el-input>
            </el-col>
            <el-col :span="10" style="text-align:center;">
              <!-- <img :src="authority + imgurl"/> -->
              <img :src="imgurl" v-if="imgurl" @click="getImg" style=" cursor: pointer;"/>
            </el-col>
            <!-- <el-col :span="4">
                <i class="el-icon-refresh"
                    v-if="imgurl"
                    style="font-size: 20px; cursor: pointer;" title="刷新"
                    @click="refreshImg"
                    >
                </i>
            </el-col>           -->

            <el-col :span="4">
              <i class="el-icon-refresh"
                 style="font-size: 20px; cursor: pointer;" title="刷新"
                 @click="getImg"
              >
              </i>
            </el-col>
          </el-form-item>
          <div style="text-align: center;">
            <el-button @click.prevent="login" @keyup.enter="login" type="primary" native-type="submit"
                       style="width: 150px;">登录
            </el-button>
            <el-button @click="register" style="width: 150px;">注册</el-button>
          </div>
          <el-button type="text" style="float: right;" @click="forgetPwd">忘记密码？</el-button>

          <!--        <div style="margin: 10px 0px 10px 0;">-->
          <!--          <el-button @click.prevent="login" @keyup.enter="login" type="primary" native-type="submit"-->
          <!--                     style="width: 100%;">登录-->
          <!--          </el-button>-->
          <!--        </div>-->
          <!--        <div>-->
          <!--          <el-button @click="register" style="width: 100%;">注册</el-button>-->
          <!--        </div>-->
        </el-form>
        <register v-if="showRegister" @registerCallback="registerCallback"/>
        <forget-pwd v-if="showForget" @forgetCallback="forgetCallback"
                    :currentName="user.name"/>
      </el-card>
    </div>


    <div style="position:fixed;color: #80d1ff;font-size: 10px;bottom: 10px;width: 100%;">
      <center>北京红云融通技术有限公司 Copyright ©
        <span style="margin-left: 15px">V3.3.4</span>
      </center>
    </div>


  </div>
</template>
<script>
import {Loading} from "element-ui";
import {mapMutations} from "vuex";
import Register from './Register';
import ForgetPwd from "./ForgetPwd";
import CryptoJS from 'crypto-js'

export default {
  components: {ForgetPwd, Register},
  data: vm => ({
    user: {
      name: "",
      password: "",
      code: "",
      key: ""
    },
    showError: false,
    showForget: false,
    showRegister: false, //显示注册面板
    rules: {
      name: [
        {required: true, message: '请输入邮箱地址', trigger: 'blur'},
        {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
      ],
    },
    imgurl: '',
    emailList: []
  }),
  mounted() {
    window.document.body.style.backgroundImage = 'url(' + require("../../assets/login-bg.png") + ')';
    window.document.body.style.backgroundRepeat = 'no-repeat';
    window.document.body.style.backgroundSize = 'cover';
    window.document.body.style.position = 'relative';
    localStorage.removeItem('token')
    this.getImg()
  },
  destroyed() {
    window.document.body.style.backgroundImage = '';
  },
  created() {
    this.getEmailList()
  },
  computed: {
    emails() {
      // 如果inputEmail中没有任何东西，则不处理
      if (!this.user.name) return [];
      // 手动输入@符号，如果@符号首次出现的位置大于等于第零个位置时，则不处理
      if (this.user.name.indexOf('@') > -1) return [];
      let emailArr = [];
      for (let i = 0; i < this.emailList.length; i++) {
        emailArr.push(this.user.name + this.emailList[i]);
      }
      return emailArr;
    }
  },
  methods: {
    ...mapMutations(["setLogin"]),
    forgetPwd() {
      this.showForget = true;
    },
    setInput(mail) {
      this.user.name = mail
    },
    keyupEnter() {
      document.onkeydown = e => {
        let body = document.getElementsByTagName("body")[0];
        if (
          e.keyCode === 13 &&
          e.target.baseURI.match(/inputbook/) &&
          e.target === body
        ) {
          this.login();
        }
      };
    },
    login() {
      // this.testMenu()
      // return
      this.$refs.user.validate(valid => {
        if (valid) {
          let loading = Loading.service({
            fullscreen: true,
            text: "数据加载中..."
          });
          let param = {
            username: this.user.name,
            password: window.getMD5(this.user.password),
            code: this.user.code,
            key: this.user.key
          }
          this.$axios.post(this.baseUrl3 + 'security/login', param)
            .then(({data: {msg, data, code}}) => {
              if (code == 20000) {
                localStorage.setItem('userName', this.user.name)
                localStorage.setItem('token', data)
                this.getMenusByRole(data)
              } else {
                this.$message.error('请求失败，原因：' + msg)
                this.getImg()
              }
              loading.close();
            })
            .catch(error => {
              loading.close();
              this.$message({
                showClose: true,
                message: "系统异常",
                type: "error"
              });
              console.log(error);
            });
        }
      })
    },
    register() {
      this.showRegister = true
    },
    registerCallback(val) {
      this.showRegister = false;
      if (val != false) {
        this.user.name = val.name
      }
    },
    forgetCallback(val) {
      this.showForget = false;
      if (val != false) {
        this.user.name = val.name
      }
    },
    // 刷新验证码
    // refreshImg(){
    //     const num = Math.ceil(Math.random()*10)
    //     this.imgurl = 'imageCode?' + num
    // },
    getEmailList() {
      this.$axios.get(this.baseUrl3 + 'security/mailbox/suffix/getAll')
        .then(({data: {code, msg, data}}) => {
          this.emailList = data;
        })
        .catch(error => {
          console.log(error)
        })
    },
    getImg() {
      this.user.code = '';
      this.$axios.get(this.baseUrl3 + 'security/imageCode')
        .then(({data: {code, msg, data}}) => {
          if (code >= 0) {
            this.imgurl = data ? data.image : '';
            this.user.key = data ? data.key : ''
          } else {
            console.log(msg)
          }
          // console.log(this.imgurl)
        })
        .catch(error => {
          console.log(error)
        })
    },
    /*
    * 1.将登录状态和菜单存到session，以便刷新页面保留登录状态
    * 2.将数据存到stroe，便于页面获取数据
    */
    storeData(menus) {
      //加密menus
      const secretKey = 'i7T4MtYsiT0i9zB4iaQrFs3rTzx0BhF5'
      let newMenus = CryptoJS.AES.encrypt(JSON.stringify(menus), secretKey).toString()
      localStorage.setItem('menus', newMenus);
      this.setLogin(menus)
    },

    // 获取用户角色拥有的菜单
    getMenusByRole(token) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.baseUrl3 + 'role/findAllByRoles/' + this.user.name)
        .then(({data: {msg, data, code}}) => {
          loading.close();
          if (code == 20000) {
            this.storeData(data);

            if (data.length == 0) {
              this.$message.warning('该账户没有任何菜单权限，请联系管理员分配');
              this.$router.push({
                path: '/'
              });
            } else {
              this.$router.push({
                path: data[0].route
              });
            }

          } else {
            this.$message.error('获取用户权限失败，原因：' + msg)
          }

        })
        .catch(error => {
          loading.close();
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    testMenu() {
      this.$axios
        .get(this.baseUrl3 + "app/findAll")
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.storeData('token_akdsjfhskjhdf', data)

            // this.setLogin(data)
            if (data.length == 0) {
              this.$message.warning('该账户没有任何菜单权限，请联系管理员分配')
              this.$router.push({
                path: '/'
              });
            } else {
              this.$router.push({
                path: data[0].route
              });
            }

          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
  }
};
</script>
<style scoped>
.hintBox {
  width: 100%;
  max-height: 120px;
  overflow-y: scroll;
  overflow-x: auto;
  position: absolute;
  z-index: 999;
  background-color: #fff;
}

.container {
  position: fixed;
  top: 48%;
  left: 71%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 5px;
  width: 380px;
}

.header {
  /* color: rgb(82, 186, 252); */
  text-align: center;
  font-weight: 400;
}

.err {
  color: #e83b3b;
  margin-top: -20px;
}

.container >>> .el-button--primary {
  background-color: #1cc3ea;
  border-color: #1cc3ea;

}

.container >>> .el-button {
  padding: 10px 18px;
}

.tips {
  margin-top: 8px;
}

.findBack {
  text-align: right;
  cursor: pointer;
}
</style>
